import { Loader } from '@fe-learner-common/components/Loader';
import { DetailsPageSkeleton } from '@components/DetailsPageSkeleton';
import {
  BaseHTTPError,
  ForbiddenError,
  NotFoundError,
  useAppContext,
} from '@fe-core';
import { useParams } from 'react-router-dom';
import { useError } from '@hooks/useError';
import { SelfRegRoute } from '@routes/selfreg/SelfregRoute';
import { useSelfregSessionDetails } from './hooks/data/useSelfregSessionDetails';
import { publishBaseErrorEvent } from '@fe-core-events';
import { useIntl } from 'react-intl';

const useHandleError = (error: BaseHTTPError | null) => {
  const emitError = useError();
  const intl = useIntl();

  if (!error) {
    return;
  }

  switch (true) {
    case error instanceof ForbiddenError:
      publishBaseErrorEvent({
        consumer: 'fe-learner-catalog',
        event: 'feedback.ui.error.base',
        type: 'modal',
        status: 'error',
        config: {
          title: intl.formatMessage({
            id: 'catalog.course.error.selfreg.disabled.title',
          }),
          description: intl.formatMessage({
            id: 'catalog.course.error.selfreg.disabled.description',
          }),
        },
      });
      break;
    case error instanceof NotFoundError:
      publishBaseErrorEvent({
        consumer: 'fe-learner-catalog',
        event: 'feedback.ui.error.base',
        type: 'modal',
        status: 'error',
        config: {
          title: intl.formatMessage({
            id: 'learner.common.error.notFound.title',
          }),
          description: intl.formatMessage({
            id: 'learner.common.error.notFound.description',
          }),
        },
      });
      break;

    default:
      emitError({
        error: error,
        errorMapOverride: {
          type: 'modal',
        },
      });
  }
};

export const SelfRegRouteLoader = () => {
  const { sessionId } = useParams();
  const { isLoading: isLoadingAppContext } = useAppContext();

  const { error, isLoading: isLoadingSessionDetails } =
    useSelfregSessionDetails({
      enabled: true,
      sessionId,
    });

  useHandleError(error);

  const isLoading = isLoadingAppContext || isLoadingSessionDetails;

  return (
    <Loader isLoading={isLoading} skeleton={<DetailsPageSkeleton />}>
      <SelfRegRoute />
    </Loader>
  );
};
